
export default {
    name: 'EmptyState',
    props: {
        title: String,
        slogan: String,
        icon: String
    }
}
